import { create } from 'zustand';
import type { PendingKnowledgeDelete } from '../../../types/knowledge';

type KnowledgeDatabaseSharedStore = {
  pendingDelete: PendingKnowledgeDelete | null;
  setPendingDelete: (pendingDelete: PendingKnowledgeDelete | null) => void;
  reset: () => void;
};

export const useKnowledgeDatabaseSharedStore =
  create<KnowledgeDatabaseSharedStore>((set) => ({
    pendingDelete: null,
    setPendingDelete: (pendingDelete) => set({ pendingDelete }),
    reset: () => set({ pendingDelete: null }),
  }));
